<template>
  <update-business-member-field
    title="Email"
    :value="member.email"
    :member="member"
    :is-loading="isLoading"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="updateUserEmail"
  >
    <template>
      <base-email-field placeholder="Enter email" v-model="email" required />
    </template>
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    member: {
      type: Object,
      required: true,
    },
    businessId: String,
    userId: String,
  },
  data() {
    return {
      isLoading: false,
      isEditing: false,
      email: "",
    };
  },
  methods: {
    handleIsEditing($event) {
      this.email = this.member.email;
      this.isEditing = $event;
    },
    async updateUserEmail() {
      try {
        this.isLoading = true;
        await this.$axios.post(`/businesses/${this.businessId}/members/${this.userId}/update-email`, {
          email: this.email,
        });
        this.isEditing = false;
        this.$emit("updated", {
          ...this.member,
          email: this.email,
        });
      } catch (err) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Error updating email",
          message: "We were not able to save the email. Please reload the page to try again.",
          error: err,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
